import './RemoveSuggestionFeedbackModal.scss'

import React, {Component} from 'react'
import {Modal} from 'react-bootstrap'
import {connectModal} from 'redux-modal'

import OpRadio from 'common/views/components/OpRadio'
import { MATCH_FEEDBACK_OPTIONS} from 'common/constants'

import { handleMatchFeedbackSubmit } from 'broker/redux/manage_users'

class RemoveSuggestionFeedback extends Component {
  constructor(props) {
    super(props)

    this.state = {
      feedbackReason: null
    }
  }

  async handleSubmit() {
    const { handleHide, agent_party_id, broker_op_id, dispatch } = this.props
    const { feedbackReason: feedback_type } = this.state

    await dispatch(handleMatchFeedbackSubmit({ agent_party_id, broker_op_id, feedback_type }))
    handleHide()
  }

  render() {
    const {show, handleHide} = this.props

    return (
      <Modal show={show} className="RemoveSuggestionFeedback">
        <div className="RemoveSuggestionFeedbackModal">
          <div className="RemoveSuggestionFeedbackModal__close-modal -icon-close" onClick={handleHide}/>
          <div className="RemoveSuggestionFeedbackModal__header">
            <div className="RemoveSuggestionFeedbackModal__title_row">
              <div className="RemoveSuggestionFeedbackModal__title">Remove Agent?</div>
            </div>
          </div>
          <div className="RemoveSuggestionFeedbackModal__body">
            <div className="RemoveSuggestionFeedbackModal__question_prompt">
              <p>Are you sure you want to remove this agent? Please provide a reason why:</p>
            </div>
            <div className="RemoveSuggestionFeedbackModal__radio_options">
              {_.map(MATCH_FEEDBACK_OPTIONS, mfo =>
                <OpRadio
                  style={{marginTop: 9, marginBottom: 9}}
                  label={mfo.label}
                  checked={mfo.value === this.state.feedbackReason}
                  onChange={() => this.setState({feedbackReason: mfo.value})}
                  divClass={'-radio-spacing'}
                  key={mfo.value}
                />
              )}
            </div>
          </div>
          <div className="-buttons">
            <button id="cancel-button" onClick={() => {
              setImmediate(() => {
                handleHide()
              })
            }}>Cancel
            </button>
            <button id="save-button" disabled={!this.state.feedbackReason}
                    onClick={() => this.handleSubmit()}>Remove
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

const RemoveSuggestionFeedbackModal = connectModal({name: 'RemoveSuggestionFeedbackModal', destroyOnHide: true})(RemoveSuggestionFeedback)

export default RemoveSuggestionFeedbackModal
